export enum Modules {
  APP_NAME = 'simulation',
  SALARY_ADVANCE_NAME = 'salary-advance',
  COMMON_NAME = 'common',
}
